package gr.tech.site.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

/** Outer card wrapping the featured fixture row — MediumGreen background with shadow, mirrors GrowersProfileContainer */
val DlcFixtureContainerStyle = CssStyle {
    base {
        Modifier
            .padding(24.px)
            .backgroundColor(Theme.MediumGreen.rgb)
            .borderRadius(12.px)
            .boxShadow(
                BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 8.px,
                    blurRadius = 30.px,
                    spreadRadius = 4.px,
                    color = rgba(100, 100, 111, 0.5)
                )
            )
    }
    Breakpoint.MD {
        Modifier.padding(32.px)
    }
}

/** Small uppercase label above the fixture name — "GROWER'S CHOICE" */
val DlcEyebrowStyle = CssStyle.base {
    Modifier
        .fontSize(0.7.cssRem)
        .fontWeight(700)
        .letterSpacing(0.15.em)
        .textTransform(TextTransform.Uppercase)
        .color(Theme.DarkGreen.rgb)
}

/** "DLC HORTICULTURAL LISTED" pill badge — dark green fill, white text */
val DlcHortiBadgeStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.InlineBlock)
        .backgroundColor(Theme.DarkGreen.rgb)
        .color(Colors.White)
        .fontSize(0.7.cssRem)
        .fontWeight(700)
        .letterSpacing(0.1.em)
        .textTransform(TextTransform.Uppercase)
        .padding(topBottom = 4.px, leftRight = 10.px)
        .borderRadius(100.px)
        .width(Width.FitContent)
}

/** Individual stat tile — frosted glass effect on MediumGreen background */
val DlcStatTileStyle = CssStyle.base {
    Modifier
        .height(128.px)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .justifyContent(JustifyContent.Center)
        .alignItems(AlignItems.Center)
        .backgroundColor(rgba(255, 255, 255, 0.2))
        .border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.35))
        .borderRadius(8.px)
        .padding(topBottom = 12.px, leftRight = 16.px)
        .textAlign(TextAlign.Center)
}

/** The large value inside a stat tile (e.g. "2.6 µmol/J") */
val DlcStatValueStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .fontWeight(700)
        .color(Colors.White)
        .lineHeight(1.2)
        .margin(top = 16.px)
}

/** The small label beneath a stat value (e.g. "PPE Efficiency") */
val DlcStatLabelStyle = CssStyle.base {
    Modifier
        .fontSize(0.7.cssRem)
        .color(Colors.White)
        .opacity(75.percent)
        .lineHeight(1.3)
}
